export function canScrollY(overflow: string, overflowY: string): boolean {
  return (
    overflowY === 'auto' ||
    overflowY === 'scroll' ||
    overflow === 'auto' ||
    overflow === 'scroll'
  );
}

export function shouldVirtualizeList(
  itemCount: number,
  minItemCount: number
): boolean {
  return itemCount >= minItemCount;
}

export function isValidScrollToIndex(
  index: number | null | undefined
): index is number {
  return index !== null && index !== undefined && index >= 0;
}

export function findIndexById(
  ids: readonly string[],
  targetId: string | null | undefined
): number | null {
  if (!targetId) {
    return null;
  }

  const index = ids.findIndex((id) => id === targetId);
  return index >= 0 ? index : null;
}

export function isClippingScrollContainer(
  overflow: string,
  overflowY: string,
  scrollHeight: number,
  clientHeight: number
): boolean {
  return (
    canScrollY(overflow, overflowY) && scrollHeight > clientHeight + 1
  );
}

export function isElementClippingScroll(element: HTMLElement): boolean {
  const { overflow, overflowY } = window.getComputedStyle(element);
  return isClippingScrollContainer(
    overflow,
    overflowY,
    element.scrollHeight,
    element.clientHeight
  );
}

export function getNearestScrollElement(
  element: HTMLElement | null
): HTMLElement | null {
  let current = element?.parentElement ?? null;

  while (current) {
    if (isElementClippingScroll(current)) {
      return current;
    }

    current = current.parentElement;
  }

  const scrollingElement = document.scrollingElement;
  return scrollingElement instanceof HTMLElement
    ? scrollingElement
    : document.documentElement;
}

export function getListScrollMargin(
  list: HTMLElement,
  scrollParent: HTMLElement
): number {
  const parentRect = scrollParent.getBoundingClientRect();
  const listRect = list.getBoundingClientRect();
  return listRect.top - parentRect.top + scrollParent.scrollTop;
}
